module.exports = __webpack_public_path__ + "img/bg-check-addr.ab1e006b.png";